import { SendOutlined } from "@ant-design/icons";
import { useLazyQuery } from "@apollo/react-hooks";
import {
  Avatar,
  Button,
  Card,
  Col,
  DatePicker,
  Empty,
  Form,
  Input,
  Layout,
  Row,
  Table,
  Tooltip,
} from "antd";
import * as moment from "moment";
import React, { useEffect, useState } from "react";
import Empty_SendFirstAnnouncement from "../../../Assets/Images/Empty/Empty_SendFirstAnnouncement.svg";
import { AddAnnouncementDrawer } from "../../../Components/Drawers/AddAnnouncement";
import { Loader } from "../../../Components/Loader";
import { GET_ANNOUNCEMENTS_LIST } from "../../../Graphql/queries";
import "./AnnouncementsList.less";

const { Content } = Layout;
const { RangePicker } = DatePicker;
const { REACT_APP_ASSETS_URL } = process.env;

export const AnnouncementsListPage = ({ userType }) => {
  const [showAddNewAnnouncementDrawer, setShowAddNewAnnouncementDrawer] =
    useState(false);

  const [GET_ANNOUNCEMENTS_LIST_QUERY, { data, loading, previousData }] =
    useLazyQuery(GET_ANNOUNCEMENTS_LIST, {
      fetchPolicy: "cache-and-network",
    });

  useEffect(() => {
    GET_ANNOUNCEMENTS_LIST_QUERY({
      variables: {
        user_id: localStorage.getItem("user_id"),
      },
    });
  }, []);

  const onFilterChange = (values) => {
    let requestParams = {};
    requestParams.user_id = localStorage.getItem("user_id");

    if (values.message) requestParams.message = `%${values.message}%`;
    else if (values.announcement_date) {
      requestParams.announcement_startdate = moment(
        new Date(values.announcement_date[0]).setHours(0, 0, 0, 0)
      ).format();
      requestParams.announcement_enddate = moment(
        new Date(values.announcement_date[1]).setHours(23, 59, 59, 999)
      ).format();
    }

    GET_ANNOUNCEMENTS_LIST_QUERY({
      variables: requestParams,
    });
  };

  const onSendAnnouncementSuccess = () => {
    GET_ANNOUNCEMENTS_LIST_QUERY({
      variables: {
        user_id: localStorage.getItem("user_id"),
      },
    });
    setShowAddNewAnnouncementDrawer((c) => !c);
  };

  const columns = [
    {
      title: "Announcement Message",
      key: "announcement_message",
      render: (record) => {
        return <span>{record.announcementDetails.announcement_message}</span>;
      },
    },
    {
      title: "Sent to",
      key: "sent_to",
      render: (record) => {
        return (
          <Avatar.Group maxCount={4}>
            {record.announcementDetails.users.map((item, index) => {
              if (item.userDetails.profile_image) {
                return (
                  <Avatar
                    key={index}
                    src={REACT_APP_ASSETS_URL + item.userDetails.profile_image}
                  />
                );
              } else {
                return (
                  <Avatar key={index}>
                    {item.userDetails.first_name?.charAt(0).toUpperCase() +
                      item.userDetails.last_name?.charAt(0).toUpperCase()}
                  </Avatar>
                );
              }
            })}
          </Avatar.Group>
        );
      },
    },
    {
      title: "Date & time",
      key: "created_at",
      render: (record) => {
        return (
          <span>
            {moment(record.announcementDetails.created_at).format(
              "DD MMMM YYYY HH:mm:ss"
            )}
          </span>
        );
      },
    },
  ];

  return (
    <Content className="site-body-layout mt-5">
      <>
        <Row>
          <Col>
            <Button
              shape="round"
              icon={<SendOutlined />}
              className="d-flex align-items-center"
              size="large"
              onClick={() => setShowAddNewAnnouncementDrawer((c) => !c)}
            >
              Send announcement
            </Button>
          </Col>
        </Row>
        <div className="announcementsListSec">
          <div className="announcementsSearch mt-3">
            <Form name="basic" onFinish={onFilterChange}>
              <Row gutter={15}>
                <Col xs={24} md={9} lg={10} xl={12}>
                  <Tooltip
                    trigger={["focus"]}
                    title="Announcement Message"
                    placement="topLeft"
                    overlayClassName="numeric-input"
                  >
                    <Form.Item name="message">
                      <Input placeholder="Announcement Message" />
                    </Form.Item>
                  </Tooltip>
                </Col>
                <Col xs={24} md={9} lg={10} xl={8}>
                  <Tooltip
                    trigger={["focus"]}
                    title="Select Date"
                    placement="topLeft"
                    overlayClassName="numeric-input"
                  >
                    <Form.Item name="announcement_date">
                      <RangePicker className="customDatepicker" />
                    </Form.Item>
                  </Tooltip>
                </Col>
                <Col
                  xs={24}
                  md={6}
                  lg={4}
                  xl={4}
                  className="text-md-right text-center"
                >
                  <Form.Item>
                    <Button
                      type="primary"
                      size="large"
                      shape="round"
                      htmlType="submit"
                      className="px-5"
                    >
                      Search
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </div>
          {loading ? (
            <Loader />
          ) : data?.announcements?.length > 0 ? (
            <Card className="announcementTableList">
              <Table
                columns={columns}
                dataSource={data?.announcements}
                loading={loading}
              />
            </Card>
          ) : (
            <Card className="h-100 w-100">
              <div className=" d-flex flex-column align-items-center justify-content-center py-5">
                <Empty
                  image={Empty_SendFirstAnnouncement}
                  description="Make an announcement now!"
                  className=""
                />
                <Button
                  shape="round"
                  icon={<SendOutlined />}
                  className=""
                  size="large"
                  onClick={() => setShowAddNewAnnouncementDrawer((c) => !c)}
                >
                  Send announcement
                </Button>
              </div>
            </Card>
          )}
        </div>
      </>
      {showAddNewAnnouncementDrawer && (
        <AddAnnouncementDrawer
          visible={showAddNewAnnouncementDrawer}
          toggleDrawer={() => setShowAddNewAnnouncementDrawer((c) => !c)}
          onSendAnnouncementSuccess={onSendAnnouncementSuccess}
        />
      )}{" "}
    </Content>
  );
};
